import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import {
  FrontClearanceForm,
  FrontClearanceListResponse,
} from "../types";
import {
  selectFrontClearanceForm,
  selectFrontClearancePage,
  selectFrontClearancePerPage,
} from "./selector";
import { frontClearanceActions } from "./slice";

let isFetchingList = false;

export function* handleGetFrontClearanceList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectFrontClearancePage);
    const perPage: number = yield select(selectFrontClearancePerPage);

    const response: FrontClearanceListResponse = yield call(
      request,
      `${API_URL}/front-clearance/list?page=${page}&perPage=${perPage}`,
      { method: "GET" }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(frontClearanceActions.getFrontClearanceListSuccess(payload));
    } else {
      yield put(frontClearanceActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectFrontClearancePage);

    if (page === 1) {
      yield put(frontClearanceActions.getFrontClearanceListError(message));
    } else {
      yield put(frontClearanceActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddFrontClearance() {
  const form: FrontClearanceForm = yield select(selectFrontClearanceForm);

  try {
    yield call(request, `${API_URL}/front-clearance`, {
      method: "POST",
      body: JSON.stringify({
        superModel: Number(form.masterModel),
        year: Number(form.year),
        cabinType: form.driverCabin.trim(),
        structureType: Number(form.bodyType),
        normalFrontSpace: Number(form.optimalDistance),
        minFrontSpace: Number(form.minimalDistance),
        manufacturer: Number(form.manufacturer),
        model: Number(form.masterModel),
        remarks: form.note.trim(),
      }),
    });

    yield put(frontClearanceActions.addFrontClearanceSuccess());
    yield put(frontClearanceActions.getFrontClearanceList());
  } catch (error) {
    yield put(
      frontClearanceActions.addFrontClearanceError((error as Error).message)
    );
  }
}

export function* frontClearanceSaga() {
  yield takeLeading(
    frontClearanceActions.getFrontClearanceList.type,
    handleGetFrontClearanceList
  );
  yield takeLeading(
    frontClearanceActions.getNextPageItems.type,
    handleGetFrontClearanceList
  );
  yield takeLatest(
    frontClearanceActions.addFrontClearance.type,
    handleAddFrontClearance
  );
}

export default frontClearanceSaga;
